exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-d89d3d5e]{cursor:pointer}.card-body-minimum[data-v-d89d3d5e]{min-height:100px}", ""]);

// exports
